import { render, staticRenderFns } from "./GraphObject.vue?vue&type=template&id=13ad48a8&scoped=true&"
import script from "./GraphObject.vue?vue&type=script&lang=js&"
export * from "./GraphObject.vue?vue&type=script&lang=js&"
import style0 from "./GraphObject.vue?vue&type=style&index=0&id=13ad48a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ad48a8",
  null
  
)

export default component.exports